import { DatePicker as ShellDatePicker, DatePickerProps } from '@e3dc-react/shell/Elements/InputFields/picker/DatePicker'
import React, { FC, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'
import { useTheme } from '@mui/material'
import moment from '@e3dc-react/shell/Libs/moment'

interface LocalProps extends Omit<DatePickerProps, 'onChange'> {
  name: string
  format?: string
}

/**
 * Date picker component for formik
 * Changes the formik field value based on passed name from props
 */
const DatePicker: FC<LocalProps> = props => {
  const theme = useTheme()
  const { handleChange: handleFieldChange } = useFormikContext()
  const [, field] = useField(props.name)

  const hasError = useMemo<boolean>(() => {
    return Boolean(field.error)
  }, [field])

  const helperText = useMemo<string | undefined>(() => {
    return field.error
  }, [field.error])

  return (
    <ShellDatePicker
      {...props}
      onChange={value => handleFieldChange(props.name)(`${value?.format()}`)}
      value={moment(field.value)}
      format={props.format}
      iconPaddingRight={theme.spacing(2)}
      label={props.label}
      helperText={hasError ? helperText : undefined}
    />
  )
}

DatePicker.displayName = 'DatePicker'

export default DatePicker
